import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadDesignSystemPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'デザインシステム figma 発注 ガイドライン'}
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/design-system/done/'}
          title="ご入力いただきありがとうございます | デザインシステム発注ガイド | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
